<template>
    <div>
        <l-map :zoom="zoom" :center="centerLatLng" :options="mapObtions">
            <l-tile-layer :attribution="attribution" :url="url"></l-tile-layer>
            <l-marker v-if="!invalidMaker" ref="marker" :lat-lng="markerLatLng">
                <l-popup >
                    <slot name="boxPopup"></slot>
                </l-popup>
            </l-marker>
        </l-map>
    </div>
</template>

<script>
import { LMap, LTileLayer, LPopup, LMarker} from "vue2-leaflet";
import "leaflet/dist/leaflet.css";  
import { Icon } from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: '/img/marker-icon-2x.png',
    iconUrl: '/img/marker-icon.png',
    shadowUrl: '/img/marker-shadow.png'
});

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPopup
    },

    props:{
        startPopupOn: {
            type: Boolean,
            required: false,
            default: false
        },
        addressLatLng: {
            type: Object,
            required: false
        },
        zoomControl: {
            type: Boolean,
            required: false,
            default: true
        },
        zoom: {
            type: Number,
            required: true
        }
    },

    data(){
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution:'&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
            markerLatLng: {lat: 0, lng: 0},
            invalidMaker: true,
            centerLatLng: [0,0],
            mapObtions: { 
                zoomControl: this.zoomControl,
                zoomSnap: true
            }

        };
    },

    methods: {
        configMarker(){ 
            if(this.addressLatLng && this.addressLatLng.lat && this.addressLatLng.lng){
                this.invalidMaker = false;
                const markerLat = this.addressLatLng.lat;
                const markerLng = this.addressLatLng.lng;
                this.markerLatLng = { lat: markerLat, lng: markerLng };
                this.centerLatLng = [markerLat, (markerLng - 0.01)];
                this.configPopup();
            }else{
                this.markerIsInvalid();
            }
        },

        configPopup(){
            this.$nextTick(() => {
                if(this.startPopupOn){
                    this.$refs.marker.mapObject.openPopup();
                }
            });
        },

        markerIsInvalid(){
            this.$emit('markerIsInvalid', this.invalidMaker);
        }
    },

    mounted() { 
        this.configMarker();
    }

}
</script>

<style>
</style>
